import { useAppDispatch, useAppSelector } from 'app/hooks';
import Loader from 'components/atoms/loader';
import Video from 'components/organisms/VideoCard';
import { selectAuth } from 'features/auth/authSlice';
import { getNfts, selectNft } from 'features/auth/nftSlice';
import { useEffect, useRef, useState } from 'react';
import './MobileExplore.css';
import { Grid, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { NormalButton } from 'components/atoms/Button';

const MobileExplorePage = () => {
  const nftState = useAppSelector(selectNft);
  const dispatch = useAppDispatch();
  const authState = useAppSelector(selectAuth);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [autoScroll, setAutoScroll] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!nftState.nfts) dispatch(getNfts());
    //eslint-disable-next-line
  }, [authState.id]);

  const scrollDown = (amount: number) => {
    if (containerRef.current)
      containerRef.current.scrollBy({ behavior: 'smooth', top: amount });
  };

  console.log('nftState', nftState);

  return (
    <div ref={containerRef} className="video__cont">
      {nftState.loading ? (
        <Loader />
      ) : nftState.nfts ? (
        nftState.nfts.length === 0 ? (
          <>
            <Grid
              style={{
                width: '70%',
                display: 'flex',
                position: 'absolute',
                zIndex: '1000',
                margin: '20px 15%',
                justifyContent: 'space-around',
              }}
            >
              <IconButton
                sx={{
                  position: 'fixed',
                  top: 20,
                  left: 20,
                  zIndex: 99,
                  color: 'white',
                }}
                onClick={() => navigate('/')}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
              <NormalButton
                onClick={() => {
                  navigate(`/explore/nft`);
                }}
                sx={{
                  width: '110px',
                  height: '47px',
                  backgroundColor: '#ccaf35',
                }}
              >
                Explore NFT
              </NormalButton>
              <NormalButton
                onClick={() => {
                  navigate(`/explore/otr`);
                }}
                sx={{
                  width: '110px',
                  height: '47px',
                }}
              >
                Explore OTR
              </NormalButton>
            </Grid>
          </>
        ) : (
          nftState.nfts.map(nft => (
            <Video
              setCurrentIndex={setCurrentIndex}
              currentIndex={currentIndex}
              data={nft}
              key={nft.id}
              url={nft.image}
              scrollDown={autoScroll ? scrollDown : undefined}
              autoScroll={autoScroll}
              setAutoScroll={setAutoScroll}
            />
          ))
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default MobileExplorePage;
